


  export const getGroupRoomInUsersHandler = (socketState, userId, groupRoomId) => {
    if (socketState) {
      socketState.emit('groupRoomIn-users', {
        userId: userId,
        groupRoomId: groupRoomId,
      });
    }  
  };